export function messageDate(message) {
    const value = message?.sentAt || message?.createdAt;
    const date = value ? new Date(value) : null;
    return date && !Number.isNaN(date.getTime()) ? date : null;
}

export function sortMessagesChronologically(messages) {
    return [...(messages || [])].sort((left, right) => (
        (messageDate(left)?.getTime() || 0) - (messageDate(right)?.getTime() || 0)
    ));
}

export function messageDayKey(message) {
    const date = messageDate(message);
    if (!date) return "unknown";
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()]
        .map((part) => String(part).padStart(2, "0"))
        .join("-");
}

export function formatPersianMessageDay(message) {
    const date = messageDate(message);
    if (!date) return "تاریخ نامشخص";
    return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    }).format(date);
}

export function groupMessagesByPersianDay(messages) {
    const groups = [];
    sortMessagesChronologically(messages).forEach((message) => {
        const key = messageDayKey(message);
        let group = groups[groups.length - 1];
        if (!group || group.key !== key) {
            group = {key, label: formatPersianMessageDay(message), messages: []};
            groups.push(group);
        }
        group.messages.push(message);
    });
    return groups;
}
